import { IconArrowLeft as ArrowLeft } from "@tabler/icons-react";
import { SectionHeader } from "../components/shared/SectionHeader";

export function PrivacyPage({ t }) {
  return (
    <main>
      <section className="relative overflow-hidden pt-32 pb-24 md:pt-40 md:pb-32">
        <div
          className="orb"
          style={{
            width: 440,
            height: 440,
            background: "hsl(var(--brand) / 0.18)",
            top: 80,
            right: -140,
          }}
        />

        <div className="container-x relative">
          <a href="/" className="btn-pill btn-ghost mb-10 w-fit text-sm">
            <ArrowLeft className="h-4 w-4" />
            {t.privacy.back}
          </a>

          <SectionHeader eyebrow={t.privacy.eyebrow} title={t.privacy.title} />

          <div className="reveal mt-12 grid gap-6 lg:grid-cols-2">
            {t.privacy.sections.map((section) => (
              <section
                key={section.title}
                className="rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--surface))] p-6 md:p-7"
              >
                <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
                  {section.title}
                </h3>
                <div className="mt-5 space-y-4 text-base leading-relaxed">
                  {section.paragraphs?.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  {section.lines ? (
                    <div className="space-y-2">
                      {section.lines.map((line) => (
                        <p key={line}>{line}</p>
                      ))}
                    </div>
                  ) : null}
                  {section.items ? (
                    <ul className="space-y-2">
                      {section.items.map((item) => (
                        <li key={item} className="flex gap-3">
                          <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brand" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              </section>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
